import { InjectionToken } from '@angular/core';

/** Injectable seam for the global `window` — lets code that reads `window.location` (e.g.
 *  `authInterceptor`'s `RequestUrl` header) be tested against a fixed fake instead of the real,
 *  shared browser global. `window.location` is Unforgeable in Chrome (`Object.defineProperty`
 *  on it throws), so stubbing it directly in a spec isn't possible — this token is the only way
 *  to make such code deterministic under test. */
export const WINDOW = new InjectionToken<Window>('WINDOW', {
  providedIn: 'root',
  factory: () => window,
});
